import {firestore, database} from '@src/db';
import { ref, onValue } from 'firebase/database';
import {FcmEvent} from '@common/FcmEvent';
let unsubscribeConfigWeb = null;
let unsubscribeInfoConnected = null;


export const state = {
  configWeb: {},
  isOnline: true,
};

export const configLoadedObj = new FcmEvent(10000);
export function getConfigLoaded() {
  return configLoadedObj.getPromise();
}
configLoadedObj.getPromise().then(()=>{
  console.log('ConfigLoaded Loaded');
});

export const actions = {
  init({ commit }) {
    if(unsubscribeConfigWeb) {
      unsubscribeConfigWeb();
    }
    if(unsubscribeInfoConnected) {
      unsubscribeInfoConnected();
    }
    try {
      unsubscribeConfigWeb = firestore.collection('config').doc('web_med').onSnapshot((snapshot) => {
        const value = {...snapshot.data(), id: snapshot.id};
        if(value.minVersion?.version>=process.env.VUE_APP_VERSION_NUMBER) {
          if(window.navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations()
              .then(function(registrations) {
                for(const registration of registrations) {
                  registration.unregister?.();
                }
              });
          }
        }
        commit('updateConfigWeb', value);
        configLoadedObj.resolve();
      },
      (error)=>{
        configLoadedObj.reject(error);
      },
      ()=>{
        // configLoadedObj.resolve();
      });
      unsubscribeInfoConnected = onValue(ref(database, '.info/connected'), (connectedSnap) => {
        commit('updateIsOnline', connectedSnap.val() === true);
      });
    } catch(err) {
      console.error('Erro onSnapshot config', err);
    }


  },

};

export const mutations = {
  updateConfigWeb(state, newValue) {
    state.configWeb = newValue;
  },
  updateIsOnline(state, newValue) {
    state.isOnline = newValue;
  },
};
